module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAPPz8/7/EP//EIaGhlFhFRI9FjcwEjUkADUcED0YDCAcABQcAFEEBBwQCCQMABQQAD0AADEAAC0AAAgICCQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAAAAAAAAAACH5BAEHABkALAAAAAAgACAAAAWxYCaOZGmeaKqubOu+cCzPdG0Og33iNeb/wKAwWJpkBMikAHOJDH9KQQEjMh6jGCSmoVggG5VL1qecUkVYcjRtiE7XyArmAFf6KIVydi3xOepJP3lJb2sMPg+AWj6DSIVRhxgIiksWGI1Se1F9GAmUGHKYj0qcnoqCenV9Fp9QhGdXSWIUrWqOGWdrFYtqQEuamSJUcD8VEhA/FJxRBBgAI0/R0i48Ojs51tna29zd3jMhADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadW_S4.gif
// module id = kfLe
// module chunks = 48